import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { customDecrypt, customEncode, customEncrypt, SharedFacade } from '@piqet-angular/data';
import { SwalService } from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { menu } from 'libs/features/src/lib/menu/menu';
import { Subscription, take } from 'rxjs';

@Component({
  selector: 'piqet-angular-product-sidebar',
  templateUrl: './product-sidebar.component.html',
  styleUrls: ['./product-sidebar.component.scss'],
})
export class ProductSidebarComponent implements OnDestroy {
  @ViewChildren('accord') parents!: QueryList<NgbAccordion>;
  @ViewChildren('childaccord') children!: QueryList<NgbAccordion>;
  @ViewChild('accordion') accordion!: NgbAccordion;

  closeOthers = true;
  activeIdsMain: string[] = [];
  activeIdsSub: string[] = [];
  currentRoute: any;
  productId: any;
  menuItems: any;
  subMenu: any = [];
  productConfigId: any;
  sideBarCall!: Subscription;
  @Output() productNameEvent = new EventEmitter<any>();

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    this.setDynamicMenu();
  }
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  iSTourOn: boolean = false;
  guidedTourData!: Subscription;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (!this.iSTourOn) this.updateHeight();
  }
  constructor(
    public readonly sharedFacade: SharedFacade,
    public readonly route: ActivatedRoute,
    public readonly router: Router,
    private readonly elementRef: ElementRef,
    private readonly projectsService: ProjectsService,
    private readonly sharedService: SharedService,
    private readonly reportsService: ReportsService,
    private readonly swalService: SwalService
  ) {
    const url = location.href.split('/');
    this.currentRoute = url[url.length - 1].split('?')[0];
    this.route.queryParams.subscribe((values: any) => {
      this.currentRoute = this.currentRoute
        ? location.href.split('/')[location.href.split('/').length - 1].split('?')[0]
        : '';
      let value: any = customDecrypt(values.param ? values.param : '');
      this.productId = value?.id || '';
      // if (
      //   this.currentRoute !== 'chart-at-glance' &&
      //   this.currentRoute !== 'report-generation'
      // ) {
      //   value = value?.id ?? '';
      // } else {
      //   value =  value?.id ?? '';
      // }
      // this.productId =value;
      if (
        this.currentRoute == 'chart-at-glance' ||
        this.currentRoute == 'report-generation' ||
        this.currentRoute == 'setting'
      )
        this.activeIdsSub = [];
      if (this.currentRoute == 'product-list' && this.menuItems?.length) {
        return (this.activeIdsSub = []);
      }
      if (
        (value ||
          this.currentRoute == 'chart-at-glance' ||
          this.currentRoute == 'report-generation') &&
        !values?.aTr
      ) {
        this.changeCurrentRoute();
      }
    });

    this.router.events.pipe(take(1)).subscribe((x: any) => {
      this.menuItems = [...menu];
      this.menuItems = this.menuItems.find((x: any) => x.text.toLowerCase() == 'products')?.submenu;
      this.menuItems.forEach((item: any, i: any) => {
        if (x?.routerEvent?.urlAfterRedirects?.includes(`?param=`)) {
          this.menuItems[1].isActive = true;
          return;
        } else if (
          x?.routerEvent?.urlAfterRedirects?.includes(`report-generation`) ||
          x?.routerEvent?.urlAfterRedirects?.includes(`chart-at-glance`)
        ) {
          this.menuItems[2].isActive = true;
          return;
        } else {
          item.isActive = this.checkActiveLink(x, item, i);
          return;
        }
      });
    });
    this.changeCurrentRoute();
    this.setDynamicMenu();
  }

  ngOnDestroy(): void {
    this.menuItems?.forEach((item: any) => {
      item.isActive = false;
    });
    this.sideBarCall?.unsubscribe();
    this.guidedTourData?.unsubscribe();
    this.sharedService.scenarioNameFunc('');
    localStorage.removeItem('scenarioName');
  }

  ngAfterViewInit() {
    this.guidedTourData = this.sharedService.startTourObs$.subscribe((data: any) => {
      if (!data[0]) this.updateHeight();
      if (data[0] && data[1] == 'init') {
        document.getElementById('scrollableDiv')?.classList.add('gt-class');
      }
      this.iSTourOn = data;
    });

    // Initialize the height
    const observer = new MutationObserver(() => {
      if (!this.iSTourOn) this.updateHeight();
    });

    if (!this.iSTourOn)
      observer.observe(this.sideMenu.nativeElement, { attributes: true, subtree: true });
  }

  updateHeight() {
    var screenZoomLevel = window.devicePixelRatio || 1;
    var finalHeight;

    const adjustedVh = this.calculateAdjustedVh(screenZoomLevel);
    const adjustedHeightInPx = this.vhToPixels(adjustedVh);
    finalHeight = adjustedHeightInPx;

    if (screenZoomLevel < 1) {
      this.sideMenu.nativeElement.style.minHeight = finalHeight + 'px';
    } else {
      this.sideMenu.nativeElement.style.minHeight = '61vh';
    }

    const height = this.sideMenu.nativeElement.offsetHeight;
    var contentDiv = document.getElementById('scrollableDiv') as HTMLElement;
    if (contentDiv) contentDiv.style.height = height + 20 + 'px';
  }

  calculateAdjustedVh(zoomLevel: any) {
    const zoomLevels = [1, 0.8, 0.75, 0.5, 0.33, 0.25];
    const assumedHeights = [61, 63, 65, 70, 80, 84];

    let closestZoomLevel = zoomLevels.reduce((prev, curr) => {
      return Math.abs(curr - zoomLevel) < Math.abs(prev - zoomLevel) ? curr : prev;
    });

    let index = zoomLevels.indexOf(closestZoomLevel);
    return assumedHeights[index];
  }

  vhToPixels(vh: any) {
    const viewportHeightPx = window.innerHeight;
    return (vh / 100) * viewportHeightPx;
  }

  ngOnInit(): void {
    this.productConfigId = localStorage.getItem('productConfigId');

    // Set Settings as active by default if on settings route
    if (this.currentRoute === 'setting') {
      this.activeIdsMain = []; // Settings has no submenu, so accordion should be collapsed
    }

    this.sideBarCall = this.sharedService.productSidebarData$.pipe().subscribe((data: any) => {
      this.changeCurrentRoute();
      this.setDynamicMenu();
      if (data == 'charts') {
        this.openChartSection();
      }
    });
  }

  openChartSection() {
    this.activeIdsMain = [];
    this.activeIdsSub = [];
    this.activeIdsMain.push('panel-main-' + 2);
    this.activeIdsSub.push('panel-sub-' + 0);
  }

  checkActiveLink(data: any, item: any, i: any) {
    if (data.snapshot && i == 0) {
      let route = this.route.snapshot.routeConfig?.path;
      return route?.includes('setting');
    }
    if (data) {
      return (
        data?.routerEvent?.urlAfterRedirects?.includes('/' + item.link) ??
        data?.urlAfterRedirects?.includes('/' + item.link)
      );
    } else {
      return true;
    }
  }

  collapsePanel(children: any, link: any) {
    this.accordion.collapseAll();
    const element = this.elementRef.nativeElement.querySelector('.menutext');
    const elementClasses = element.classList;
    if (elementClasses) {
      elementClasses.add('active');
    }
    this.navigate(children, null, link);
    this.router.navigate([
      `projects/product-configuration/${customEncode(btoa(this.productConfigId))}/setting`,
    ]);
  }

  changeCurrentRoute() {
    this.currentRoute = this.currentRoute
      ? location.href.split('/')[location.href.split('/').length - 1].split('?')[0]
      : '';

    // Open Products section if on product routes
    if ((this.productId || this.currentRoute == 'product-list') && this.menuItems?.length) {
      this.openScenario(this.menuItems[1]?.submenu);
    }

    // Open Report section if on report routes
    if (this.currentRoute == 'chart-at-glance' || this.currentRoute == 'report-generation') {
      this.activeIdsMain = ['panel-main-2'];
      this.navigate(
        this.menuItems?.find(
          (x: any) =>
            x.text.toLowerCase() ==
            (this.currentRoute == 'report-generation' || this.currentRoute == 'chart-at-glance'
              ? 'report'
              : 'scenarios')
        )
      );
    }
  }

  setDynamicMenu() {
    this.productConfigId = localStorage.getItem('productConfigId');
    this.projectsService.getProductSidebarData(this.productConfigId).subscribe((res: any) => {
      let submenu: any = [{ name: 'Configuration', description: 'configurations' }];
      if (res) {
        this.subMenu = [];
        res?.data?.products?.forEach((element: any) => {
          if (
            element.productScopes !== undefined &&
            element.productScopes !== null &&
            element.productScopes.length > 0
          ) {
            this.subMenu.push(this.createSubmenuArray(element));
          }
        });
        this.subMenu.forEach((item: any) => {
          item.submenu.unshift(...submenu);
          item.submenu.forEach((submenuItem: any) => {
            submenuItem.text = submenuItem.name;
            submenuItem.link = submenuItem.description;
          });
        });
        this.sharedService.accessProductSideMenuArray(this.subMenu);
        this.setSubmenu(res.data);
        if ((this.productId || this.currentRoute == 'product-list') && this.menuItems?.length)
          this.openScenario(this.menuItems[1]?.submenu);
        if (this.menuItems[1]?.submenu[0]?.productId)
          localStorage.setItem('pId', this.menuItems[1].submenu[0]?.productId);
      }
      this.productNameEvent.emit(res.data?.productName);
    });
  }

  openScenario(subMenu: any) {
    if (this.currentRoute == 'product-list') {
      this.openScenarioDropdown();
    } else {
      const scenarioIndx = subMenu.findIndex((x: any) => x.productId == this.productId);
      this.openScenarioDropdown(1, scenarioIndx);
    }
  }

  openScenarioDropdown(indx?: any, scenarioIndx?: any) {
    this.activeIdsMain = [];
    this.activeIdsSub = [];
    if (!indx && this.currentRoute == 'product-list') {
      this.activeIdsMain.push(`panel-main-1`);
    } else if (indx) {
      this.activeIdsMain.push(`panel-main-${indx}`);
      this.activeIdsSub.push(`panel-sub-${scenarioIndx}`);
    }
  }

  setSubmenu(data: any) {
    this.menuItems.forEach((el: any) => {
      if (el.text.toLowerCase() == 'products') {
        el.submenu = this.subMenu;
        return;
      }
    });
    this.currentRoute = this.currentRoute
      ? location.href.split('/')[location.href.split('/').length - 1].split('?')[0]
      : '';
    this.navigate(
      this.menuItems.find(
        (x: any) =>
          x.text.toLowerCase() ==
          (this.currentRoute == 'report-generation' || this.currentRoute == 'chart-at-glance'
            ? 'report'
            : 'products')
      )
    );
  }

  createSubmenuArray(element: any) {
    const link = element.hasOwnProperty('description') ? element.description : '#';
    return {
      text: element.name,
      link: link,
      productId: element.productId,
      submenu: element.productScopes,
    };
  }

  async onParentMenuClick(children: any, event?: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const panelId = this.getPanelIdForMenu(children);

    if (this.activeIdsMain.includes(panelId)) {
      this.activeIdsMain = [];
    } else {
      this.activeIdsMain = [panelId];
    }

    if (children.link) {
      if (children.text.toLowerCase() === 'products') {
        const encryptedValue = customEncode(btoa(this.productConfigId));
        this.router.navigate([`projects/product-configuration/${encryptedValue}/product-list`]);
      } else if (children.text.toLowerCase() === 'report') {
        const activeProductProjectId: any = localStorage.getItem('productConfigId');
        const reportFormData: any = await this.reportsService.checkReportFromDataForProduct(
          activeProductProjectId
        );
        if (reportFormData && reportFormData.data) {
          const { item1, item2 } = reportFormData.data;

          if (item1 === false) {
            if (item2) {
              await this.swalService.confirmNew(
                'Report validation',
                item2,
                undefined,
                undefined,
                true
              );
            }
            return false;
          }

          return true;
        }
        const encryptedValue = customEncode(btoa(this.productConfigId));
        this.router.navigate([`projects/product-configuration/${encryptedValue}/chart-at-glance`]);
      }
    }

    // Update active states
    this.updateParentMenuState(children);
  }

  private getPanelIdForMenu(children: any): string {
    const index = this.menuItems.findIndex((item: any) => item.text === children.text);
    return `panel-main-${index}`;
  }

  onAccordionChange(panelId: any) {
    const id = panelId?.panelId ?? panelId;

    const index = parseInt(id.replace('panel-main-', ''));

    if (!isNaN(index) && this.menuItems && this.menuItems[index]) {
      const activeMenu = this.menuItems[index];
      this.updateParentMenuState(activeMenu);
    }
  }

  private updateParentMenuState(children: any) {
    this.menuItems?.forEach((data: any) => {
      if (data.text === children.text) {
        data.isActive = true;
      } else {
        data.isActive = false;
      }
    });
  }

  async navigate(children: any, ele?: any, link?: any, event?: any) {
    if (event && link && ele) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.currentRoute = link ? link : this.currentRoute;

    if (this.isSpecialReportRoute(children, link)) {
      const activeProductProjectId: any = localStorage.getItem('productConfigId');
      const reportFormData: any = await this.reportsService.checkReportFromDataForProduct(
        activeProductProjectId
      );
      if (reportFormData && reportFormData.data) {
        const { item1, item2 } = reportFormData.data;

        if (item1 === false) {
          if (item2) {
            await this.swalService.confirmNew(
              'Report validation',
              item2,
              undefined,
              undefined,
              true
            );
          }
          return;
        } else {
          this.handleSpecialReportNavigation(children, ele, link);
        }
      }
    } else {
      this.handleStandardNavigation(children, ele, link);
    }
  }

  private isSpecialReportRoute(children: any, link?: any): boolean {
    return (
      children?.link == 'chart-at-glance' ||
      link == 'report-generation' ||
      link == 'chart-at-glance'
    );
  }

  private handleSpecialReportNavigation(children: any, ele?: any, link?: any) {
    if (children?.text == 'Report') {
      this.activateReportSection();
    }
    if (link && ele) {
      this.navigateToProductConfiguration(ele, link);
      return;
    }

    if (this.currentRoute.toLowerCase() != 'setting') {
      this.processMenuItems(children, ele);
    } else {
      this.activateSettingsSection();
    }
  }

  private handleStandardNavigation(children: any, ele?: any, link?: any) {
    if (link && ele) {
      this.navigateWithQueryParams(ele, link);
    }

    if (this.currentRoute.toLowerCase() != 'setting') {
      this.processMenuItems(children, ele, true);
    } else {
      this.activateSettingsSection();
    }
  }

  private activateReportSection() {
    this.deactivateAllMenuItems();

    const reportSection = this.menuItems.find((item: any) => item.text === 'Report');
    if (reportSection) {
      reportSection.isActive = true;
      reportSection.submenu?.forEach((x: any) => {
        x.isActive = x?.link == this.currentRoute;
      });
    }
  }

  private deactivateAllMenuItems() {
    this.menuItems?.forEach((data: any) => {
      data.isActive = false;
      if (data?.submenu) {
        data.submenu.forEach((submenuItem: any) => {
          submenuItem.isActive = false;
          if (submenuItem?.submenu) {
            submenuItem.submenu.forEach((subItem: any) => {
              subItem.isActive = false;
            });
          }
        });
      }
    });
  }

  private navigateToProductConfiguration(ele: any, link: string) {
    this.router.navigate([
      `projects/product-configuration/${customEncode(
        btoa(ele?.productId ?? this.productConfigId)
      )}/${link}`,
    ]);
  }

  private navigateWithQueryParams(ele: any, link: string) {
    const encryptedValue = customEncrypt(ele?.productId);
    this.router.navigate(
      [`projects/product-configuration/${customEncode(btoa(this.productConfigId))}/${link}`],
      {
        queryParams: { param: encryptedValue },
      }
    );
  }

  private processMenuItems(children: any, ele?: any, isStandardNav: boolean = false) {
    if (typeof children != 'string' || Object.keys(children) || children.length) {
      this.updateMenuItemStates(children);
      this.handleReportRoutes();

      if (children && children.text != 'Report') {
        this.updateScenarioStates(children, ele);
      }

      if (this.shouldUpdateActivePanels(isStandardNav)) {
        this.updateActiveReportPanels();
      }

      this.sharedService.scenarioNameFunc(ele?.text);
    }
  }

  private updateMenuItemStates(children: any) {
    this.menuItems?.forEach((data: any) => {
      data.isActive = false;
      data?.submenu?.forEach((x: any) => {
        if (this.isReportLink(x?.link)) {
          x.isActive = x?.link == this.currentRoute;
        }
      });

      if (children == 'isScenario') {
        this.accordion.collapseAll();
      } else if (data?.link == children.link) {
        data.isActive = true;
      }
    });
  }

  private isReportLink(link: string): boolean {
    return link == 'report-generation' || link == 'chart-at-glance' || link == 'interpretation';
  }

  private handleReportRoutes() {
    if (this.currentRoute == 'chart-at-glance' || this.currentRoute == 'report-generation') {
      if (this.activeIdsMain.length === 0 || !this.activeIdsMain.includes('panel-main-2')) {
        this.activeIdsMain = ['panel-main-2'];
      }
    }
  }

  private updateScenarioStates(children: any, ele?: any) {
    this.menuItems[1].submenu.forEach((y: any) => {
      y['activeScenario'] = false;
    });

    children?.submenu?.forEach((x: any) => {
      x['activeScenario'] = false;
      if (x?.productId === (ele?.productId ?? this.productId)) {
        x['activeScenario'] = true;
        children.isActive = true;
      }
    });
  }

  private shouldUpdateActivePanels(isStandardNav: boolean): boolean {
    if (isStandardNav) {
      return (
        (this.currentRoute == 'chart-at-glance' && history.state.isFromNext) ||
        this.currentRoute == 'report-generation'
      );
    }
    return this.currentRoute == 'chart-at-glance' || this.currentRoute == 'report-generation';
  }

  private updateActiveReportPanels() {
    this.activeIdsMain = [];
    this.activeIdsSub = [];
    this.activeIdsMain.push('panel-main-2');
  }

  private activateSettingsSection() {
    this.menuItems?.forEach((data: any) => {
      data.isActive = data.link == 'setting';
      data?.submenu?.forEach((x: any) => {
        x.isActive = false;
      });
    });

    if (this.menuItems?.some((data: any) => data.link == 'setting' && data.isActive)) {
      this.accordion.collapseAll();
    }
  }
}
